import React from 'react';
import './ThresholdInput.scss';
import { ValueBasedDiscount } from '../storeTypes';
import { FaPlus } from 'react-icons/fa';
import { ButtonComponent } from '../../../../ReusableComponents/Button/ButtonComponent';
import { ThresholdErrorField } from '../EditStoreSettings';
import SingleThresholdInput from './SingleThresholdInput';

export type InputType = 'threshold' | 'discount';

interface Props {
  discountThresholds: ValueBasedDiscount[];
  onChange: (discountThresholds: ValueBasedDiscount[]) => void;
  errorFields: ThresholdErrorField[];
}

const ThresholdInput = ({
  discountThresholds,
  onChange,
  errorFields,
}: Props) => {
  const onChangeSingleInput = (
    value: string,
    inputIndex: number,
    inputType: InputType
  ) => {
    const newDiscountThresholds = discountThresholds.map(
      (valueBasedDiscount, index) => {
        if (inputIndex === index) {
          return {
            threshold:
              inputType === 'threshold' ? value : valueBasedDiscount.threshold,
            discount:
              inputType === 'discount' ? value : valueBasedDiscount.discount,
          };
        } else {
          return valueBasedDiscount;
        }
      }
    );
    onChange(newDiscountThresholds);
  };

  const onClickAddThreshold = () => {
    onChange([...discountThresholds, { threshold: '0', discount: '0' }]);
  };

  const onClickDeleteThreshold = (deleteIndex: number) => {
    onChange(discountThresholds.filter((_, index) => index !== deleteIndex));
  };

  return (
    <div>
      <p>Thresholds for discount (not accumulative):</p>
      {discountThresholds.map((valueBasedDiscount, index) => (
        <SingleThresholdInput
          key={index}
          index={index}
          onChange={onChangeSingleInput}
          onClickDelete={onClickDeleteThreshold}
          valueBasedDiscount={valueBasedDiscount}
          errorField={errorFields[index]}
        />
      ))}
      <div className="threshold__button">
        <ButtonComponent
          variant="outlined"
          startIcon={<FaPlus />}
          onClick={onClickAddThreshold}
        >
          {'Add threshold for discount'}
        </ButtonComponent>
      </div>
    </div>
  );
};

export default ThresholdInput;
